import { DOCS_FORM_NAMES } from "core/consts";
import { PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT } from "core/schemas/shared";
import { importAuctionToDRVGeneralForm } from "dsl/ecosystems/PatientForms/RehabForms/DRVGeneralForm/importAuction";
import { FormFieldConfigFactory } from "..";
import { DRVGeneralFormSchema } from "./schema";
import { DRVGeneralFormSections } from "./sections";

export const getDRVGeneralFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DRV_GENERAL
> = () => {
  return {
    auctionToForm: importAuctionToDRVGeneralForm,
    config: { canPrint: true, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        application_submitted: value?.application_submitted ?? "",
        application_submitted_applicable:
          value?.application_submitted_applicable ?? undefined,
        before_retirement_pension: value?.before_retirement_pension ?? "",
        before_retirement_pension_applicable:
          value?.before_retirement_pension_applicable ?? undefined,
        care_person_necessary: value?.care_person_necessary ?? undefined,
        claim_for_damages_approved:
          value?.claim_for_damages_approved ?? undefined,
        claim_for_damages_description:
          value?.claim_for_damages_description ?? undefined,
        claim_for_damages_file_number:
          value?.claim_for_damages_file_number ?? "",
        claim_for_damages_origin: value?.claim_for_damages_origin ?? "",
        consent_of_the_insured: value?.consent_of_the_insured ?? undefined,
        contact_guardian: value?.contact_guardian ?? "",
        contributions_to_foreign_insurance_current:
          value?.contributions_to_foreign_insurance_current ?? undefined,
        contributions_to_foreign_insurance_info:
          value?.contributions_to_foreign_insurance_info ?? undefined,
        contributions_to_foreign_insurance_info_from_to:
          value?.contributions_to_foreign_insurance_info_from_to ?? "",
        contributions_to_foreign_insurance_info_state:
          value?.contributions_to_foreign_insurance_info_state ?? "",
        contributions_to_statutory_pension:
          value?.contributions_to_statutory_pension ?? undefined,
        doctor_in_charge_in_hospital: value?.doctor_in_charge_in_hospital ?? "",
        doctor_in_charge_in_hospital_first_name:
          value?.doctor_in_charge_in_hospital_first_name ?? "",
        doctor_in_charge_in_hospital_phone:
          value?.doctor_in_charge_in_hospital_phone ?? "",
        employment_status: value?.employment_status ?? undefined,
        gender_extended: value?.gender_extended ?? undefined,
        health_damage_file_number: value?.health_damage_file_number ?? "",
        health_damage_origin: value?.health_damage_origin ?? "",
        health_damage_present: value?.health_damage_present ?? undefined,
        health_damages_description: value?.health_damages_description ?? "",
        hospital_name_address: value?.hospital_name_address ?? "",
        insurance_company_name_address:
          value?.insurance_company_name_address ?? "",
        insurance_name: value?.insurance_name ?? "",
        insurance_type: value?.insurance_type ?? undefined,
        jobcenter_name: value?.jobcenter_name ?? "",
        last_employment: value?.last_employment ?? "",
        legal_guardian_email: value?.legal_guardian_email ?? "",
        legal_guardian_house_number: value?.legal_guardian_house_number ?? "",
        legal_guardian_phone: value?.legal_guardian_phone ?? "",
        legal_guardian_town: value?.legal_guardian_town ?? "",
        legal_guardian_type: value?.legal_guardian_type ?? undefined,
        legal_guardian_zip_code: value?.legal_guardian_zip_code ?? "",
        marital_status: value?.marital_status ?? undefined,
        needs_disability_equipment: value?.needs_disability_equipment ?? "",
        needs_disability_equipment_applicable:
          value?.needs_disability_equipment_applicable ?? undefined,
        patient_bank_account_holder: value?.patient_bank_account_holder ?? "",
        patient_bank_iban: value?.patient_bank_iban ?? "",
        patient_bank_name: value?.patient_bank_name ?? "",
        patient_birth_name: value?.patient_birth_name ?? "",
        patient_birthdate: value?.patient_birthdate ?? undefined,
        patient_city: value?.patient_city ?? "",
        patient_first_name: value?.patient_first_name ?? "",
        patient_last_name: value?.patient_last_name ?? "",
        patient_maiden_name: value?.patient_maiden_name ?? "",
        patient_nationality: value?.patient_nationality ?? "",
        patient_phone_number: value?.patient_phone_number ?? "",
        patient_street_housenumber: value?.patient_street_housenumber ?? "",
        patient_unable_to_work_before_hospitalization:
          value?.patient_unable_to_work_before_hospitalization ?? undefined,
        patient_unable_to_work_before_hospitalization_date:
          value?.patient_unable_to_work_before_hospitalization_date ??
          undefined,
        patient_zipcode: value?.patient_zipcode ?? "",
        pension_insurance_company_name:
          value?.pension_insurance_company_name ?? "",
        postal_code_doctor: value?.postal_code_doctor ?? "",
        preferred_rehab_clinic: value?.preferred_rehab_clinic ?? "",
        prior_employment_status: value?.prior_employment_status ?? undefined,
        requested_rehab_service: value?.requested_rehab_service ?? undefined,
        requested_rehab_service_type_insured:
          value?.requested_rehab_service_type_insured ?? undefined,
        requested_rehab_service_type_relatives:
          value?.requested_rehab_service_type_relatives ?? undefined,
        retirement_pension_received: value?.retirement_pension_received ?? "",
        retirement_pension_received_applicable:
          value?.retirement_pension_received_applicable ?? undefined,
        risk_of_incapacity_caused_by_accident_third_person:
          value?.risk_of_incapacity_caused_by_accident_third_person ??
          undefined,
        send_documents_per_email: value?.send_documents_per_email ?? false,
        send_documents_per_email_description:
          value?.send_documents_per_email_description ?? "",
        social_worker_name_number: value?.social_worker_name_number ?? "",
        special_payments_from_civil_services:
          value?.special_payments_from_civil_services ?? undefined,
        statutory_pension_insurance_number:
          value?.statutory_pension_insurance_number?.slice(
            0,
            PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
          ) ?? "",
        street_house_number_doctor: value?.street_house_number_doctor ?? "",
        structured_treatment_plan: value?.structured_treatment_plan ?? "",
        third_party_request: value?.third_party_request ?? undefined,
        town_doctor: value?.town_doctor ?? "",
        unemployment_benefit_type_2:
          value?.unemployment_benefit_type_2 ?? undefined,
        visually_impaired_document:
          value?.visually_impaired_document ?? undefined,
      };
    },
    header: ({ translations }) =>
      translations.patientForms.drvGeneralForm.title,
    schema: DRVGeneralFormSchema,
    sections: DRVGeneralFormSections,
    title: ({ translations }) => translations.patientForms.drvGeneralForm.title,
  };
};
